export default __webpack_public_path__ + "static/media/centerbid-logo.4cd14084.png";